import { styled } from '../../Utilities';
import { DialogBase } from './Dialog.base';
import { getStyles } from './Dialog.styles';
export var Dialog = styled(DialogBase, getStyles, undefined, {
  scope: 'Dialog'
});
Dialog.displayName = 'Dialog';